import Component from 'component';
import _debounce from 'lodash/debounce';
class ReviewsSlider extends Component {
  constructor(el) {
    super(el);
    this.initSlick();
  }
  setupDefaults() {
    this.dom = {
      $slider: this.$el.find('.reviews-slider__inner'),
      $slides: this.$el.find('.reviews-slider-list__review')
    };
  }
  addListeners() {
    $(window).on('resize', _debounce(::this.initSlick, 100));
  }
  initSlick() {
    const _that = this;
    if (!this.dom.$slider.hasClass('slick-initialized')) {
      _that.dom.$slider.slick({
        arrows: true,
        infinite: false,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 0,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
        prevArrow:
          '<img class="slick-prev slick-arrow" src="/dist/sites/ktu/images/contentManaged/icons/icon-arrow-dark.svg?hfc-r=" alt="prev slide">',
        nextArrow:
          '<img class="slick-next slick-arrow" src="/dist/sites/ktu/images/contentManaged/icons/icon-arrow-dark.svg?hfc-r=" alt="next slide">'
      });
    }
  }
}
export default ReviewsSlider;



// WEBPACK FOOTER //
// ./src/ktu/js/components/ReviewsSlider.js